@switch (column.type) {
  @case (TABLE_COLUMN_TYPE.TEXT) {
    <div class="text-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      {{ item[column.viewKey] ? item[column.viewKey] : "-" }}
    </div>
  }

  @case (TABLE_COLUMN_TYPE.CUSTOM_DATE) {
    <div class="text-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      {{ item[column.viewKey] | dateToTimeAgo }}
    </div>
  }

  @case (TABLE_COLUMN_TYPE.FUNCTION) {
    <div class="text-{{ column.bodyAlign }} {{ column.customBodyClass }}" [innerHTML]="getColumnValue(column, item) | dom_sanitizer: 'html'"></div>
  }

  @case (TABLE_COLUMN_TYPE.CUSTOM) {
    <div class="{{ column.customBodyClass }}">
      <ng-content select=".custom"></ng-content>
    </div>
  }

  @case (TABLE_COLUMN_TYPE.DATE_TIME) {
    <div class="text-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      {{ !item[column.viewKey] || item[column.viewKey] === "-" ? "-" : (item[column.viewKey] | date: "d-MMM-yy, h:mm a") }}
    </div>
  }

  @case (TABLE_COLUMN_TYPE.DATE) {
    <div class="text-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      {{ !item[column.viewKey] || item[column.viewKey] === "-" ? "-" : (item[column.viewKey] | date: column.dateFormat || "d-MMM-yy") }}
    </div>
  }

  @case (TABLE_COLUMN_TYPE.ACTION) {
    <div class="d-flex justify-content-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      <ng-content select=".action"></ng-content>
    </div>
  }

  @case (TABLE_COLUMN_TYPE.CHECKBOX) {
    <div class="d-flex justify-content-{{ column.bodyAlign }} {{ column.customBodyClass }}">
      <div class="form-check gap-1">
        <input class="form-check-input primary-checkbox" type="checkbox" [checked]="item[column.viewKey]" onclick="return false" />
      </div>
    </div>
  }

  @case (TABLE_COLUMN_TYPE.LIST) {
    <div class="{{ column.customBodyClass }}">
      @for (label of item[column.viewKey]; track $index) {
        @if (label?.Name && $index <= 1) {
          <div class="table-label-item">
            <div>{{ label?.Name }}</div>
          </div>
        }
      }
    </div>
  }
}
